import { reactive, ref } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import { useTour } from '@orion.ui/orion';

type Props = SetupProps<typeof TourOrderSetupService.props>

export default class TourOrderSetupService extends BaseSetupService<Props> {
	static readonly props = undefined;

	readonly _tourOrder = ref<OrionTour>();

	private readonly state = reactive({
		hasData: false,
		canWrite: false,
	});

	get hasData () { return this.state.hasData; }
	get canWrite () { return this.state.canWrite; }

	constructor (props?: Props) {
		super(props);
	}

	protected onMounted () {
		super.onMounted();
		this.registerBusEvent('order-list-loaded', hasData => this.state.hasData = hasData);
		this.registerBusEvent('order-permission-loaded', canWrite => this.state.canWrite = canWrite);
		useTour('tourOrder', this._tourOrder.value);
	}

	orderListHeader () {
		return document.querySelector(`.shared-paged-list-order-header`);
	}

	orderListOrderBy () {
		return document.querySelector('.shared-paged-list-order-header');
	}
}
